import http from 'conversations-http/clients/http';
export const getToken = inboxId => http.get(`messages/v2/pubsub/token/agent`, {
  query: {
    inboxId,
    noCache: Math.random()
  }
});